import type { FaireProductEntity } from "../../entity_types/product";

export const p_h7chgnadmg: FaireProductEntity = {
  token: "p_h7chgnadmg",
  type: "product",
  name: "Wholesale Discovery Kit - Lip, Cheek, High (Not for Resale)",
  brandToken: "b_3d2wzlqi",
  brandName: "River Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ef7166e2e013b5334548a613e2637fdb275a8dfa06729c994a6489db2f78441a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da4ac0674a6ae7104dde9e215b1a938c0bf67bfd69ade95ae71079830e62aeb0.png",
    "https://cdn.faire.com/fastly/03622215f4ac813b6e1cfce1d065c74f458253cc7d29e068a5ee937b53fd8374.png",
    "https://cdn.faire.com/fastly/1ba63a0b8e35552c6a59febe31b968f5c907f75f49a7c8c737b323f7418cf293.png",
    "https://cdn.faire.com/fastly/afcc199a82d25b547c82130bca8a5aa001322eb096955d7e744951b7940595dc.png",
  ],
  priceDollars: 16,
  description:
    "Wholesale Discovery Kit at Tester Price - One Time Purchase to try our Full Size Lip, Blush, & Highlighter products.\n\nPlease note the limit of TWO per customer as this is to try the products out for future purchasing. \n\nGlow Naturally with Our Set of Lip, Blush Highlighters\nDiscover our nourishing, vegan makeup products in several kits to discover our best-selling colors.\n\nIn the kits: 1 Lip Product + 1 Blush Stick + 1 Highlighter or Bronzer",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:52.017Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
